import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./contexts/CartContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { ChatProvider } from "./contexts/ChatContext";
import { OrdersProvider } from "./contexts/OrdersContext";
import CartDrawer from "./components/feature/CartDrawer";
import ToastContainer from "./components/base/ToastContainer";
import ChatWidget from "./components/feature/ChatWidget";
import WhatsAppButton from "./components/feature/WhatsAppButton";

function InnerApp() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <>
      <AppRoutes />
      <CartDrawer />
      <ToastContainer />
      <ChatWidget />
      {!isAdminPage && <WhatsAppButton />}
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AdminAuthProvider>
          <OrdersProvider>
            <ChatProvider>
              <ToastProvider>
                <AuthProvider>
                  <CartProvider>
                    <InnerApp />
                  </CartProvider>
                </AuthProvider>
              </ToastProvider>
            </ChatProvider>
          </OrdersProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
